import { useAuth } from './useAuth';
import type { Permission } from '../auth/permissions';

export function usePermissions() {
  const { activeMembership } = useAuth();
  const perms = activeMembership?.perms ?? [];
  const can = (perm: Permission) => perms.includes(perm);
  const canAny = (...needed: Permission[]) => needed.some(can);
  return { perms, can, canAny };
}
